import { render, staticRenderFns } from "./AdminHomeVolunteerCard.vue?vue&type=template&id=3d1dca22&scoped=true"
import script from "./AdminHomeVolunteerCard.vue?vue&type=script&lang=js"
export * from "./AdminHomeVolunteerCard.vue?vue&type=script&lang=js"
import style0 from "./AdminHomeVolunteerCard.vue?vue&type=style&index=0&id=3d1dca22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1dca22",
  null
  
)

export default component.exports